import React from 'react';
import { FooterWrapper } from './footer.styles';

export const Footer = () => <FooterWrapper> </FooterWrapper>;
